export const TABLE_HEADER = [
  {
    title: "Type",
    width: 200,
    sortName: "type",
  },
  {
    title: "Extension",
    width: 200,
    sortName: "minValue",
  },
  {
    title: "Flexion",
    width: 200,
    sortName: "maxValue",
  },
  {
    title: "Survey",
    width: 200,
    sortName: "outcomeScore",
  },
  {
    title: "Date",
    width: 200,
    sortName: "createdAt",
  },
];

export const ATHLETE_TABLE_HEADER = [
  {
    title: "Region",
    width: 245,
    sortName: "region",
    marginLeft: 0,
  },
  {
    title: "Left SD",
    sortBy: "leftSd",
    width: 100,
    marginLeft: 0,
  },
  {
    title: "Right SD",
    sortBy: "rightSd",
    width: 100,
    marginLeft: 0,
  },
  {
    title: "Drop Jump",
    sortBy: "dropJump",
    width: 200,
    marginLeft: 0,
  },
  {
    title: "Created",
    width: 100,
    sortName: "createdAt",
    marginLeft: 15,
  },
];

export const ATHLETE_TABLE_HEADER_FREE_FORM = [
  {
    title: "Exam type",
    width: 245,
    sortName: "examtype",
    marginLeft: 0,
  },

  {
    title: "Created",
    width: 100,
    sortName: "createdAt",
    marginLeft: 15,
  },
];
